export const randomIntFromInterval = (min: number, max: number): string => {
  const randomNuber = Math.floor(Math.random() * (max - min + 1) + min);
  return randomNuber.toString();
};
//todo:mudar nome desta classe 